import {
  aboutUs,
  allCustomerReviews,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  legal,
  medium,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const ieConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, studentGoodDeals, hireExternal],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_ie',
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.ie/en-ie/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/en-ie/articles/360026643854-What-payment-methods-are-accepted-on-Back-Market-',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/en-ie/articles/360026646054-Where-can-I-get-delivered-and-how-much-does-it-cost-me-',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/en-ie/categories/360002106194-Returns-refunds-R%C3%BCckgabe-R%C3%BCckerstattung-Returns-refunds',
        },
        help,
        buyingGuides,
        modelsComparison,
        allCustomerReviews,
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [referFriend],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/en-ie/requests/new?ticket_form_id=12226993197084',
        },
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [medium],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
